import service from '@/utils/request'
// 查询
export function inquiryDetailUserList(param) {
	return service.request({
		method: 'POST',
		url: '/app/inquiryDetailUser/inquiryDetailUserList',
		data: param
	})
}
// 根据ID查询 不分页
export function getinquiryDetailUserById() {
	return service.request({
		method: 'POST',
		url: '/app/inquiryDetailUser/inquiryById',
	})
}
// 查询 不分页
export function inquiryDetailUserListAll() {
	return service.request({
		method: 'POST',
		url: '/app/inquiryDetailUser/list',
	})
}
// 新增
export function addInquiryDetailUser(param) {
	return service.request({
		method: 'POST',
		url: '/app/inquiryDetailUser/add',
		data: param,
	})
}
// 修改
export function editInquiryDetailUser(param) {
	return service.request({
		method: 'POST',
		url: '/app/inquiryDetailUser/edit',
		data: param
	})
}

// 批量删除
export function batchDelInquiryDetailUser(param) {
	return service.request({
		method: 'POST',
		url: '/app/inquiryDetailUser/batchDel',
		data: param
	})
}



// 删除
export function delInquiryDetailUser(param) {
	return service.request({
		method: 'POST',
		url: '/app/inquiryDetailUser/del',
		data: param
	})
}
// 导出
export function exportInquiryDetailUser(param) {
	return service.request({
		method: 'POST',
		url: '/app/inquiryDetailUser/export',
		data: param
	})
}
